export default {
  default: {
    toastText: {
      pemissionsUpdated: 'Permissions Updated',
    },
  },
}
